export default __webpack_public_path__ + "assets/Space_Engines_7-31-23.e7dde6f5.png";